
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useCallback } from 'react';
import metadata from './ResourcesData.metadata.json5';
import styles from './ResourcesData.module.scss';

function ResourcesData(props) {
    const { associationName_TWIA } = props;
    const isTWIA = associationName_TWIA === "twia"

    function Text() {
        return (<div > {'For more TWIA guides and claim resources,'}
            <a href="https://www.twia.org/claimscenter/#claims-center-section-7" target="_blank" style={{ color: '#30A6DC', cursor: 'pointer', textDecorationLine: 'none' }}> visit our website.</a>
        </div>)

    }

    const FAQTfpa = useCallback(() => {
        const url = 'https://www.twia.org/frequently-asked-questions-for-policyholders/';

        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(url, '_blank')
    }, []);

    const downloadForm = useCallback(() => {
        const url = 'https://www.twia.org/wp-content/uploads/Personal-Property-Inventory-Worksheet_Residential.xlsx';

        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(url, '_blank')
    }, []);

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        twiaGuidelines: {
            content: Text()
        },
        resourcesTfpa: {
            visible: !isTWIA
        },
        resourcesTwia: {
            visible: isTWIA
        },
        FAQClaim: {
            onClick: FAQTfpa
        },
        downloadClaim: {
            onClick: downloadForm
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {

        }

    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

ResourcesData.propTypes = {
    data: PropTypes.shape({}),
};

export default ResourcesData;